import { inject, Injectable } from '@angular/core';
import { SettingsService } from '@app/core/settings/settings.service';
import { LegalDocumentsService } from '@app/core/legal-documents/legal-documents.service';

@Injectable()
export class LegalDocumentLinksService {
  protected readonly legalDocumentsService = inject(LegalDocumentsService);
  private readonly settingsService = inject(SettingsService);

  public readonly settings = this.settingsService.settings;
  public readonly hasCookiePolicy = this.settings.legal_information?.has_cookie_policy ?? false;
  public readonly privacyPolicyHref = this.legalDocumentsService.getPrivacyPolicyHref();
  public readonly cookiePolicyHref = this.legalDocumentsService.getCookiePolicyHref();
}
